import React from 'react'

import {
  ExternalLink,
} from '../../styles/links'

const CopyrightInfo = () => (
  <div style={{textAlign: 'center', opacity: .5, fontSize: '.9rem'}}>
    &copy;
    {' '}
    {(new Date()).getFullYear()}
    {' '}
    <ExternalLink href="http://directedworks.com/">Directed Works</ExternalLink>
  </div>
)

export default CopyrightInfo



// WEBPACK FOOTER //
// ./src/views/misc/CopyrightInfo.js